(function () {
  if (window.__acCustonWheelFinderLoaded) return;
  window.__acCustonWheelFinderLoaded = true;
  var appUrl = 'https://ac-custon-sales-chat.pitsstopcustoms.chatgpt.site';
  var trackUrl = appUrl + '/api/track';
  var storageKey = 'ac_custon_wheel_finder_session_v1';
  var sessionId = null;
  function getSession() {
    if (sessionId) return sessionId;
    try {
      sessionId = localStorage.getItem(storageKey);
      if (!sessionId && window.crypto && crypto.randomUUID) {
        sessionId = crypto.randomUUID();
        localStorage.setItem(storageKey, sessionId);
      }
    } catch (_) {}
    return sessionId;
  }
  function track(eventType, extra) {
    var id = getSession();
    if (!id) return;
    var payload = Object.assign({ eventType: eventType, sessionId: id }, extra || {});
    try { fetch(trackUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), keepalive: true }).catch(function () {}); } catch (_) {}
  }
  function setCartAttribution() {
    var id = getSession();
    if (!id || !window.fetch || window.__acCustonCartAttributed) return;
    window.__acCustonCartAttributed = true;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ac_chat_session: id, ac_chat_source: 'wheel_finder' } }) }).then(function (response) {
      if (response.ok) track('cart_attribution_set');
    }).catch(function () {});
  }
  try {
    var params = new URLSearchParams(window.location.search);
    var fromProductLink = params.get('ac_chat_session');
    if (fromProductLink) {
      sessionId = fromProductLink.slice(0, 100);
      localStorage.setItem(storageKey, sessionId);
      history.replaceState({}, document.title, window.location.pathname + window.location.search.replace(/([?&])ac_chat_session=[^&]*&?/, '$1').replace(/[?&]$/, '') + window.location.hash);
      setCartAttribution();
    }
  } catch (_) {}
  var style = document.createElement('style');
  style.textContent = [
    '#ac-custon-wheel-finder-button{position:fixed;right:20px;bottom:20px;z-index:2147483000;background:#111;color:#fff;border:2px solid #e3262e;border-radius:999px;padding:13px 18px;font:700 14px/1.1 Arial,sans-serif;box-shadow:0 8px 24px rgba(0,0,0,.28);cursor:pointer}',
    '#ac-custon-wheel-finder-button:hover{background:#e3262e}',
    '#ac-custon-wheel-finder-panel{display:none;position:fixed;right:20px;bottom:76px;width:min(420px,calc(100vw - 24px));height:min(700px,calc(100vh - 96px));z-index:2147482999;background:#fff;border-radius:18px;overflow:hidden;box-shadow:0 16px 48px rgba(0,0,0,.34);border:1px solid #222}',
    '#ac-custon-wheel-finder-panel.ac-open{display:block}',
    '#ac-custon-wheel-finder-frame{width:100%;height:100%;border:0;background:#fff}',
    '@media(max-width:600px){#ac-custon-wheel-finder-button{right:12px;bottom:12px;padding:12px 15px}#ac-custon-wheel-finder-panel{right:6px;bottom:64px;width:calc(100vw - 12px);height:min(720px,calc(100vh - 76px));border-radius:14px}}'
  ].join('');
  document.head.appendChild(style);
  var button = document.createElement('button');
  button.id = 'ac-custon-wheel-finder-button';
  button.type = 'button';
  button.textContent = 'Find Your Wheels';
  button.setAttribute('aria-label', 'Open AC CUSTON Wheel Finder');
  var panel = document.createElement('div');
  panel.id = 'ac-custon-wheel-finder-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'AC CUSTON Wheel Finder');
  var frame = document.createElement('iframe');
  frame.id = 'ac-custon-wheel-finder-frame';
  frame.title = 'AC CUSTON Wheel Finder';
  frame.loading = 'lazy';
  frame.src = appUrl + '?embed=1' + (getSession() ? '&chat_session=' + encodeURIComponent(getSession()) : '');
  panel.appendChild(frame);
  window.addEventListener('message', function (event) {
    var data = event.data || {};
    if (data.type !== 'ac-custon-chat:session' || typeof data.sessionId !== 'string') return;
    sessionId = data.sessionId.slice(0, 100);
    try { localStorage.setItem(storageKey, sessionId); } catch (_) {}
    setCartAttribution();
  });
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target.closest('a[href*="/checkout"],button[name="checkout"],[type="submit"][name="checkout"]') : null;
    if (target) track('checkout_started');
  }, true);
  button.addEventListener('click', function () {
    var isOpen = panel.classList.toggle('ac-open');
    button.textContent = isOpen ? 'Close Wheel Finder' : 'Find Your Wheels';
  });
  document.body.appendChild(panel);
  document.body.appendChild(button);
}());